import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	designLabel: {
		id: 'dynamic-cards-search-page.design-search-result.label',
		defaultMessage: 'Design',
		description: 'Design search result label',
	},
});
